module.exports = __webpack_public_path__ + "static/scale-model-of-durham-distillery-in-durham-north-carolina-c60ad4d382c53ed724c6db805b097e0a.png";